import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './product-dashboard-specialservice-statistics.component.html',
    selector: 'op-product-dashboard-specialservice-statistics'
})
export class ProductDashboardSpecialServiceStatisticsComponent implements AfterViewInit {
    public revenueYesterday: number;
    public revenueToday: number
    public cancellationYesterday: number;
    public cancellationToday: number;
    public revenueCancellationYesterday: number;
    public revenueCancellationToday: number;

    constructor(private changeDetection: ChangeDetectorRef) {
        
    }

    ngAfterViewInit(): void {
        this.loadData();
    }

    private loadData() {
        setTimeout(() => {
            this.revenueYesterday = 1560;
            this.revenueToday = 3500;
            this.cancellationYesterday = 500;
            this.cancellationToday = 1000;
            this.revenueCancellationYesterday = 432;
            this.revenueCancellationToday = 1500;

            this.changeDetection.detectChanges();
        }, 500);
    }
}